import { useQuery } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import {
	type ClientPortfolioDomainEnum,
	getPortfolioDomainProductsV2,
	type ProductCategoryKeyEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useProductsQuery = (
	domain: ClientPortfolioDomainEnum | undefined,
	producerId: number | undefined,
	productCategory?: ProductCategoryKeyEnum,
) => {
	return useQuery({
		queryKey: PortfolioKeys.products(domain!, producerId!, productCategory),
		queryFn: processResponse(() =>
			getPortfolioDomainProductsV2(domain!, producerId!, productCategory),
		),
		enabled: Boolean(domain) && Boolean(producerId),
	});
};
